/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum IndicatorNaamPrestatieanalyse {
    BEHAALD_NIVEAU_CONFORM_OPP = "Behaald niveau conform OPP",
    BEOOGD_I_R_T_BEHAALD_EINDUITSTROOMNIVEAU = "Beoogd i.r.t. behaald einduitstroomniveau",
    TUSSENTIJDSE_UITSTROOM = "Tussentijdse uitstroom",
    EINDUITSTROOM = "Einduitstroom"
}
